import { render, staticRenderFns } from "./CreateLinkEmployee.vue?vue&type=template&id=649a4db1"
import script from "./CreateLinkEmployee.vue?vue&type=script&lang=js"
export * from "./CreateLinkEmployee.vue?vue&type=script&lang=js"
import style0 from "./CreateLinkEmployee.vue?vue&type=style&index=0&id=649a4db1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports